export default __webpack_public_path__ + "static/media/testimonial-2.81a61264.png";